import type { MapRestaurantPreview } from "../../../gql/getters/allRestaurantIds";
import type { LocationCoordinates } from "../../nearTo/model";

/**
 * Equirectangular squared distance — enough to order ids, and cheaper than
 * haversine inside a 1,000-item comparator.
 */
const squaredDistance = (
  origin: LocationCoordinates,
  lat: number,
  lng: number,
): number => {
  const latDelta = origin.lat - lat;
  const meanLat = ((origin.lat + lat) / 2) * (Math.PI / 180);
  const lngDelta = (origin.lng - lng) * Math.cos(meanLat);
  return latDelta * latDelta + lngDelta * lngDelta;
};

const sortRestaurantsByDistance = (
  restaurants: MapRestaurantPreview[],
  origin: LocationCoordinates | null | undefined,
): MapRestaurantPreview[] => {
  if (origin == null || restaurants.length === 0) {
    return [...restaurants];
  }

  const distanceById = new Map<number, number>();
  for (const restaurant of restaurants) {
    distanceById.set(
      restaurant.id,
      restaurant.lat == null || restaurant.lng == null
        ? Number.POSITIVE_INFINITY
        : squaredDistance(origin, restaurant.lat, restaurant.lng),
    );
  }

  return [...restaurants].sort(
    (a, b) => (distanceById.get(a.id) ?? 0) - (distanceById.get(b.id) ?? 0),
  );
};

export default sortRestaurantsByDistance;
